import React from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import SimpleReactLightbox from "simple-react-lightbox";
import { SRLWrapper } from "simple-react-lightbox";
import Reveal from "react-reveal/Reveal";

const PortfolioTwo = () => {
  return (
    <div className="CIGI_tm_section" id="portfolio">
      <SimpleReactLightbox>
        <div className="cigi_portfolio">
          <div className="container">
            <div className="positon-relative">
              <div className="cigi_title">
                <div className="title_flex">
                  <div className="left">
                    <span>Portfolio</span>
                    <h3>Creative Portfolio</h3>
                  </div>
                </div>
              </div>
              {/* End cigi_title */}
              <div className="portfolio_filter">
                <Tabs>
                  <TabList>
                    <Tab>All</Tab>
                    <Tab>Web Design</Tab>
                    <Tab>Product Design</Tab>
                    <Tab>Photography</Tab>
                  </TabList>
                  {/* End tablist */}
                  <div className="portfolio_list">
                    <SRLWrapper>
                      <TabPanel>
                        <ul className="gallery_zoom">
                          <li>
                            <Reveal effect="fadeIn">
                              <div className="inner">
                                <div className="entry cigi_portfolio_animation_wrap">
                                <a href="/img/portfolio/DevVersion.jpeg">
                                  <img
                                    src="/img/portfolio/DevVersion.jpeg"
                                    alt="Design"
                                  />
                                </a>
                              </div>
                              <div className="mobile_title">
                                <h3>DevVersion App</h3>
                                <span>Web App Design</span>
                                </div>
                              </div>
                            </Reveal>
                          </li>
                          {/* End single image block */}

                          <li>
                            <Reveal effect="fadeIn">
                              <div className="inner">
                                <div className="entry cigi_portfolio_animation_wrap">
                                  <a href="/img/portfolio/weatherflix.png">
                                    <img
                                      src="/img/portfolio/weatherflix.png"
                                      alt="Branding"
                                    />
                                  </a>
                                </div>
                                <div className="mobile_title">
                                  <h3>WeatherFlix</h3>
                                  <span>WebAppDesign</span>
                                </div>
                              </div>
                            </Reveal>
                          </li>
                          {/* End single image block */}

                          <li>
                            <Reveal effect="fadeIn">
                              <div className="inner">
                                <div className="entry cigi_portfolio_animation_wrap">
                                  <a href="/img/portfolio/dalmore.png">
                                    <img
                                      src="/img/portfolio/dalmore.png"
                                      alt="Photography"
                                    />
                                  </a>
                                </div>
                                <div className="mobile_title">
                                  <h3>DalMore Whiskey Promo Ad</h3>
                                  <span>Photography</span>
                                </div>
                              </div>
                            </Reveal>
                          </li>
                          {/* End single image block */}

                          <li>
                            <Reveal effect="fadeIn">
                              <div className="inner">
                                <div className="entry cigi_portfolio_animation_wrap">
                                  <a href="/img/portfolio/figmadevver.png">
                                    <img
                                      src="/img/portfolio/figmadevver.png"
                                      alt="Design"
                                    />
                                  </a>
                                </div>
                                <div className="mobile_title">
                                  <h3>Figma Basic Design</h3>
                                  <span>Design</span>
                                </div>
                              </div>
                            </Reveal>
                          </li>
                          {/* End single image block */}

                          <li>
                            <Reveal effect="fadeIn">
                              <div className="inner">
                                <div className="entry cigi_portfolio_animation_wrap">
                                  <a href="/img/portfolio/figma2.png">
                                    <img
                                      src="/img/portfolio/figma2.png"
                                      alt="Branding"
                                    />
                                  </a>
                                </div>
                                <div className="mobile_title">
                                  <h3>Dating App Prototype</h3>
                                  <span>Branding</span>
                                </div>
                              </div>
                            </Reveal>
                          </li>
                          {/* End single image block */}

                          <li>
                            <Reveal effect="fadeIn">
                              <div className="inner">
                                <div className="entry cigi_portfolio_animation_wrap">
                                  <a href="/img/portfolio/LaurenBridals.jpg">
                                    <img
                                      src="/img/portfolio/LaurenBridals.jpg"
                                      alt="Photography"
                                    />
                                  </a>
                                </div>
                                <div className="mobile_title">
                                  <h3>Bridal Magazine Ad</h3>
                                  <span>Photography</span>
                                </div>
                              </div>
                            </Reveal>
                          </li>
                          {/* End single image block */}
                        </ul>
                        {/* End portfolio list */}
                      </TabPanel>
                      {/* END ALL PORTFOLIO GALLERY */}

                      <TabPanel>
                        <ul className="gallery_zoom">
                          <li>
                            <div className="inner">
                              <div className="entry cigi_portfolio_animation_wrap">
                                <a href="/img/portfolio/dalmore.png">
                                  <img
                                    src="/img/portfolio/dalmore.png"
                                    alt="Branding"
                                  />
                                </a>
                              </div>
                              <div className="mobile_title">
                                <h3>DalMore Whiskey Ad</h3>
                                <span>Branding</span>
                              </div>
                            </div>
                          </li>
                          {/* End single image block */}

                          <li>
                            <div className="inner">
                              <div className="entry cigi_portfolio_animation_wrap">
                                <a href="/img/portfolio/LaurenBridals.jpg">
                                  <img
                                    src="/img/portfolio/LaurenBridals.jpg"
                                    alt="Photography"
                                  />
                                </a>
                              </div>
                              <div className="mobile_title">
                                <h3>Bridal Magazine Ad</h3>
                                <span>Photography</span>
                              </div>
                            </div>
                          </li>
                          {/* End single image block */}
                        </ul>
                        {/* End portfolio list */}
                      </TabPanel>

                      <TabPanel>
                        <ul className="gallery_zoom">
                          <li>
                            <div className="inner">
                              <div className="entry cigi_portfolio_animation_wrap">
                                <a href="/img/portfolio/figmadevver.png">
                                  <img
                                    src="/img/portfolio/figmadevver.png"
                                    alt="Design"
                                  />
                                </a>
                              </div>
                              <div className="mobile_title">
                                <h3>Figma Basic Design</h3>
                                <span>Design</span>
                              </div>
                            </div>
                          </li>
                          {/* End single image block */}

                          <li>
                            <div className="inner">
                              <div className="entry cigi_portfolio_animation_wrap">
                                <a href="/img/portfolio/figma2.png">
                                  <img
                                    src="/img/portfolio/figma2.png"
                                    alt="Branding"
                                  />
                                </a>
                              </div>
                              <div className="mobile_title">
                                <h3>Dating App Prototype</h3>
                                <span>Branding</span>
                              </div>
                            </div>
                          </li>
                        </ul>
                        {/* End single image block */}
                      </TabPanel>

                      <TabPanel>
                        <ul className="gallery_zoom">
                          <li>
                            <div className="inner">
                              <div className="entry cigi_portfolio_animation_wrap">
                                <a href="/img/portfolio/dalmore.png">
                                  <img
                                    src="/img/portfolio/dalmore.png"
                                    alt="Branding"
                                  />
                                </a>
                              </div>
                              <div className="mobile_title">
                                <h3>Dalmore Whiskey</h3>
                                <span>Branding</span>
                              </div>
                            </div>
                          </li>
                          {/* End single image block */}

                          <li>
                            <div className="inner">
                              <div className="entry cigi_portfolio_animation_wrap">
                                <a href="/img/portfolio/LaurenBridals.jpg">
                                  <img
                                    src="/img/portfolio/LaurenBridals.jpg"
                                    alt="Photography"
                                  />
                                </a>
                              </div>
                              <div className="mobile_title">
                                <h3>Bridal Magazine Ad</h3>
                                <span>Photography</span>
                              </div>
                            </div>
                          </li>
                        </ul>
                        {/* End single image block */}
                      </TabPanel>
                    </SRLWrapper>
                    {/* End tabpanel */}
                  </div>
                  {/* End list wrapper */}
                </Tabs>
              </div>
            </div>
          </div>
        </div>
      </SimpleReactLightbox>
    </div>
  );
};

export default PortfolioTwo;
